import api from '../../api/client';
import React, { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import Payments from '../../components/admin/Payments'
import PaymentAttemptsPanel from '../../components/admin/PaymentAttemptsPanel'
import Layout from '../../components/layout/Layout'
import { loadingState } from '../../recoil/atoms'
import { paymentListState } from './atoms'

const PaymentHistory = () => {
    const setLoading = useSetRecoilState(loadingState)
    const setPaymentList = useSetRecoilState(paymentListState)
    useEffect(() => {
        setLoading(true)
        api.get('users/payment_list/').then(result => {
            setPaymentList(
                result.data.sort((a, b) => {
                    return new Date(b.date) - new Date(a.date)
                })
            )
            setLoading(false)
        })
    }, [setPaymentList, setLoading])
    return (
        <Layout>
            <PaymentAttemptsPanel />
            <Payments />
        </Layout>
    )
}

export default PaymentHistory